/*
 * Project: Dynamedics Portal Web
 * Created Date: Wednesday March 8th 2023
 * Author: KasunSKarunasekara
 * -----
 * Last Modified: Tuesday June 13th 2023 4:01:07 pm
 * Modified By: Vithushan Sylvester at <vsylvester@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  isEditMode: false,
  isEventsLoading: false,
  isFiscalYearLoading: false,
  error: false,
  events: [],
  fiscalYearDetails: {}
};

const slice = createSlice({
  name: 'customCalendar',
  initialState,
  reducers: {
    //START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    //SET EDIT MODE
    setEditMode(state, action) {
      state.isEditMode = action.payload;
    },
    //START LOADING
    startEventsLoading(state) {
      state.isEventsLoading = true;
    },
    //START FISCAL YEAR LOADING
    startFiscalYearLoading(state) {
      state.isFiscalYearLoading = true;
    },
    //HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.isEventsLoading = false;
      state.error = action.payload;
    },
    // GET CUSTOMERS DATA SUCCESS
    getEventsSuccess(state, action) {
      state.isEventsLoading = false;
      state.events = action.payload;
    },
    // GET FISCAL YEAR SUCCESS
    getFiscalYearSuccess(state, action) {
      state.isFiscalYearLoading = false;
      state.fiscalYearDetails = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startEventsLoading,
  startFiscalYearLoading,
  setEditMode
} = slice.actions;

export function getCustomEvents() {
  return async (dispatch) => {
    try {
      dispatch(startEventsLoading());
      const response = await axios.get(`/custom-calendar/event`);
      dispatch(slice.actions.getEventsSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export async function addEvent(data) {
  let eventPayload = { ...data };
  try {
    const response = await axios.post(`/custom-calendar/event`, {
      ...eventPayload
    });
    return response;
  } catch (error) {
    return error;
  }
}

// ----------------------------------------------------------------------

export async function updateEvent(data, eventId) {
  let eventPayload = { ...data };
  try {
    const response = await axios.put(`/custom-calendar/event/${eventId}`, {
      ...eventPayload
    });
    return response;
  } catch (error) {
    return error;
  }
}

// ----------------------------------------------------------------------

export function getFiscalYear() {
  return async (dispatch) => {
    try {
      dispatch(startFiscalYearLoading());
      const response = await axios.get(`/custom-calendar/fiscal-year`);
      dispatch(slice.actions.getFiscalYearSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
